import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { ButtonLoader } from "Components";
import { newAuthService } from "Service/Axios";
import { saveUserProfileUrl } from "Constant/api";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";
import { Validator } from "Utils/validator";

export const OnlineProfileModal = ({
  show,
  onlineProfileData,
  toggle,
  fetchData,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    gid: "",
    profileTitle: "",
    profileUrl: "",
  });
  const [errMsg, setErrMsg] = useState({
    profileTitle: "",
    profileUrl: "",
  });

  const { gid, profileTitle, profileUrl } = formData;

  useEffect(() => {
    if (onlineProfileData) {
      setFormData({
        gid: onlineProfileData.gid || "",
        profileTitle: onlineProfileData.platform || "",
        profileUrl: onlineProfileData.profileUrl || "",
      });
    }
  }, [onlineProfileData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (!Validator.text(value)) {
      setErrMsg((prev) => ({
        ...prev,
        [name]: t(
          `common.messages.error.viewProfile.onlineProfile.${name}.blank`
        ),
      }));
    } else if (name === "profileUrl" && !Validator.isHttpsWwwUrl(value)) {
      setErrMsg((prev) => ({
        ...prev,
        profileUrl: t(
          "common.messages.error.viewProfile.onlineProfile.profileUrl.inValid"
        ),
      }));
    } else {
      setErrMsg((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      let isValid = true;
      const errors = {};

      if (!Validator.text(profileTitle)) {
        errors.profileTitle = t(
          "common.messages.error.viewProfile.onlineProfile.profileTitle.blank"
        );
        isValid = false;
      }

      if (!Validator.text(profileUrl)) {
        errors.profileUrl = t(
          "common.messages.error.viewProfile.onlineProfile.profileUrl.blank"
        );
        isValid = false;
      } else if (!Validator.isHttpsWwwUrl(profileUrl)) {
        errors.profileUrl = t(
          "common.messages.error.viewProfile.onlineProfile.profileUrl.inValid"
        );
        isValid = false;
      }

      setErrMsg((prev) => ({
        ...prev,
        ...errors,
      }));

      resolve(isValid);
    });
  };

  const onSaveOnineProfile = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      try {
        const payload = {
          key: VIEW_PROFILE_SECTIONS.onlineProfiles,
          [VIEW_PROFILE_SECTIONS.onlineProfiles]: {
            platform: profileTitle,
            profileUrl,
          },
        };

        if (gid.trim()) {
          payload[VIEW_PROFILE_SECTIONS.onlineProfiles].gid = gid;
        }

        setLoading(true);
        const response = await newAuthService(
          saveUserProfileUrl,
          "POST",
          payload
        );
        if (response.status) {
          toast.success(
            t("common.messages.notification.success.profileUpdated")
          );
          fetchData();
          toggle();
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Modal show={show} onHide={toggle} className="highlightsModal">
      <Modal.Header closeButton>
        <Modal.Title className="text-md font-medium">
          {t(
            `auth.viewProfile.${gid ? "editOnlineProfile" : "addOnlineProfile"}`
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12 col-sm-6 col-12">
            <div className="mb-3">
              <label htmlFor="profileTitle" className="form-label">
                {t("common.label.profileTitle")}
              </label>
              <input
                type="text"
                className="form-control"
                id="profileTitle"
                name="profileTitle"
                placeholder={t("common.placeHolder.profileTitle")}
                value={profileTitle}
                onChange={handleChange}
              />
              {errMsg.profileTitle && (
                <p className="error">{errMsg.profileTitle}</p>
              )}
            </div>
          </div>
          <div className="col-md-12 col-sm-6 col-12">
            <div className="mb-3">
              <label htmlFor="profileUrl" className="form-label">
                {t("common.label.profileUrl")}
              </label>
              <input
                type="profileUrl"
                className="form-control"
                id="profileUrl"
                name="profileUrl"
                placeholder={t("common.placeHolder.profileUrl")}
                value={profileUrl}
                onChange={handleChange}
              />
              {errMsg.profileUrl && (
                <p className="error">{errMsg.profileUrl}</p>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={toggle}>
          {t("common.button.cancel")}
        </Button>
        {loading ? (
          <ButtonLoader />
        ) : (
          <Button variant="primary" onClick={onSaveOnineProfile}>
            {t("common.button.save")}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
